module.exports = "<district-page></district-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/district.html
// module id = 1557
// module chunks = 0